__turbopack_context__.v({
  "audurRadio": "audurRadioButton-module-scss-module__66rUiW__audurRadio",
  "audurRadioButton": "audurRadioButton-module-scss-module__66rUiW__audurRadioButton",
  "audurRadioInput": "audurRadioButton-module-scss-module__66rUiW__audurRadioInput",
  "tooltip": "audurRadioButton-module-scss-module__66rUiW__tooltip",
});
